import React, { Component, Fragment } from 'react'
import {
  Button,
  Select,
  MenuItem,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
  Tabs,
  Tab,
  Grid,
  FormControl,
  TableFooter,
  TablePagination,
  withStyles,
  IconButton,
} from '@material-ui/core'
import Snackbar from '@material-ui/core/Snackbar'

import { weedMapList, Appcues } from '../../../utils/constants'
import { updateAtIndex, deleteAtIndex, convertArrayToOptions } from '../../../utils/array'

import EditableHOCWrapper from '../../../containers/HOC/EditableHOC'
import { EditableCheckbox, EditableReactSelect } from '../../common/EditableComponents'
import ModalDialog from '../../common/ModalDialog'
import PersistentDrawer from '../../common/PersistentDrawer'
import AddProductSync from './AddProductSync'
import SearchField from '../../common/SearchField'
import { connect } from 'react-redux'
import WeedMapMenuListItemV3 from './WeedMapMenuListItemV3'

import PropTypes from 'prop-types'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft'
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight'

const WeedMapMenuListItemV3Editable = EditableHOCWrapper(WeedMapMenuListItemV3)

class WeedMapMenuListContainerV3 extends Component {
  timeout = null

  state = {
    newCategory: false,
    activeCategory: 0,
    weedmapCategory: '',
    selectedProductsMap: {},
    thirdPartyBrandId: '',
    thirdPartyProductId: '',
    wmTags: [],
    productsToSync: [],
    allselected: false,
    term: '',
    loading: false,
    saved: false,
    page: 0,
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100],
  }

  componentDidMount() {
    if (this.props.categoryLastModified != null && this.props.categoryList.length > 0) {
      this.handleCategoryChange('', 0)
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.version !== this.props.version && nextProps.version === 3) {
      const filteredCategories = this.props.categoryList.filter((cat) => cat.active)

      const activeCategory = filteredCategories[0]

      const weedmapCategory = (activeCategory && activeCategory.wmCategory) || ''
      this.setState({
        weedmapCategory,
      })

      this.props.getWmMenuApiBrands()
    }

    if (nextProps.categoryLastModified != this.props.categoryLastModified) {
      // eslint-disable-line
      this.handleCategoryChange('', 0)
    }
  }

  componentDidMount() {
    const filteredCategories = this.props.categoryList.filter((cat) => cat.active)

    const activeCategory = filteredCategories[0]

    this.setState({
      weedmapCategory: (activeCategory && activeCategory.wmCategory) || '',
    })

    this.props.updateCategory(activeCategory && activeCategory.id)
    this.props.getBLAZEProducts(activeCategory && activeCategory.id)
  }

  onSave = (index) => (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    const product = this.props.productsList.find((prod) => prod.id === data.productId)
    let weedmapInfo = { ...data, wmThreshold: (product && product.wmThreshold) || 0 }
    this.props.onSave([weedmapInfo], afterOnSave)
  }

  onDelete = (index) => (data) => {
    this.props.disableWeedmapforProducts([data], () =>
      this.handleCategoryChange('', this.state.activeCategory),
    )
  }

  validate = (data) => {
    if (!data.categoryId) {
      this.props.onError('Please choose a category')
      return false
    }

    return true
  }

  saveNewCategory = (data, afterOnSave) => {
    if (!this.validate(data)) {
      return
    }

    this.props.onSave([data], afterOnSave)

    this.setState({
      newCategory: false,
    })
  }

  closeNewCategory = () => {
    this.setState({
      newCategory: false,
    })
  }

  handleCategoryChange = (event, activeCategory) => {
    const filteredCategories = this.props.categoryList.filter((category) => category.active)
    const weedmapCategory =
      (filteredCategories[activeCategory] && filteredCategories[activeCategory].wmCategory) || ''

    this.setState({
      activeCategory,
      weedmapCategory,
      productstoSync: [],
      selectedProductsMap: {},
    })

    this.props.updateCategory(
      filteredCategories[activeCategory] && filteredCategories[activeCategory].id,
    )
    this.props.getBLAZEProducts(
      filteredCategories[activeCategory] && filteredCategories[activeCategory].id,
    )
  }

  setWeedmapCategory = async (event) => {
    const { activeCategory } = this.state
    this.setState({ loading: true })

    const activeCategories =
      this.props.categoryList && this.props.categoryList.filter((category) => category.active)
    const categoryId =
      (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
    await this.props.performCategoryMapping(categoryId, event.target.value)
    this.props.getWmMenuApiBrands()

    this.setState({
      weedmapCategory: event.target.value,
      loading: false,
      saved: true,
    })
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }

    this.setState({ saved: false })
  }

  selectAll = (wmCategory) => (event) => {
    if (event.target.checked) {
      const { productsList = [], tagMapping = [], categoryList = [] } = this.props

      const { selectedProductsMap = {}, activeCategory } = this.state

      let updatedProductsMap = { ...selectedProductsMap }

      const activeCategories = categoryList.filter((category) => category.active)

      productsList
        .filter((product) => product.enableWeedmap)
        .forEach((product) => {
          const dataToEditIndex = tagMapping.findIndex((wmMap) => {
            return wmMap.productId === product.id
          })

          const dataToEdit = tagMapping[dataToEditIndex]

          const categoryId =
            (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
          if (dataToEdit) {
            if (!dataToEdit.thirdPartyProductId)
              updatedProductsMap = {
                ...updatedProductsMap,
                [product.id]: dataToEdit || {
                  wmTags: [(wmCategory && wmCategory.name) || ''],
                  productId: product.id,
                  categoryId,
                },
              }
          } else {
            updatedProductsMap = {
              ...updatedProductsMap,
              [product.id]: {
                wmTags: [(wmCategory && wmCategory.name) || ''],
                productId: product.id,
                categoryId,
              },
            }
          }
        })

      this.setState({
        selectedProductsMap: updatedProductsMap,
      })
    } else {
      this.setState({
        selectedProductsMap: {},
      })
    }
  }

  onRowCheck = (data, event) => {
    const { selectedProductsMap = {} } = this.state

    let updatedProductsMap = { ...selectedProductsMap }

    if (event.target.checked) {
      updatedProductsMap = { ...updatedProductsMap, [data.productId]: data }
    } else {
      delete updatedProductsMap[data.productId]
    }

    this.setState({
      selectedProductsMap: {
        ...updatedProductsMap,
      },
    })
  }

  onClose = () => {
    this.setState({
      thirdPartyBrandId: '',
      thirdPartyProductId: '',
      wmTags: [],
    })
  }

  onOpen = () => {
    this.props.getWmMenuApiBrands()
  }

  addProducts = () => {
    let { productsToSync = [], activeCategory, weedmapCategory } = this.state
    if (productsToSync && !productsToSync.length) {
      return this.props.showError('No product(s) selected!')
    }
    const activeCategories =
      this.props.categoryList && this.props.categoryList.filter((category) => category.active)

    const categoryId =
      (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''
    this.addProductModal.handleClose()

    this.props.enableWeedmapforProducts(productsToSync, () =>
      this.handleCategoryChange('', this.state.activeCategory),
    )

    this.setState({
      productsToSync: [],
      allselected: false,
    })

    const mappedData = productsToSync.map((id, key) => {
      return {
        productId: id,
        categoryId: categoryId,
        wmTags: [weedmapCategory],
        thirdPartyBrandId: '',
      }
    })
    Appcues.track('Weedmap Products Added')
    this.props.updateWeedmapMapping(mappedData)
  }

  checkAllProducts = (e) => {
    const { productsList = [] } = this.props

    if (e.target.checked) {
      let products =
        (productsList &&
          productsList.filter((product, index) => {
            return !product.enableWeedmap
          })) ||
        []
      this.setState({
        productsToSync: products.map((prod) => prod.id),
        allselected: e.target.checked,
      })
    } else this.setState({ productsToSync: [], allselected: e.target.checked })
  }

  onCheckProduct = (productId) => {
    let { productsToSync = [], mapProducts = {} } = this.state
    if (!productsToSync.includes(productId)) {
      productsToSync.push(productId)
      mapProducts = { ...this.state.mapProducts, [productId]: true }
    } else {
      let index = productsToSync.findIndex((data) => data === productId)
      productsToSync.splice(index, 1)
      mapProducts = { ...this.state.mapProducts, [productId]: false }
    }

    this.setState({
      productsToSync,
      mapProducts,
    })
  }

  openMapProductModal = () => {
    const { productsList = [] } = this.props

    let length =
      productsList.filter((product) => {
        return !product.enableWeedmap
      }).length || 0
    if (length > 0) {
      this.addProductModal.handleClickOpen()
      this.setState({
        mapProducts: {},
        productsToSync: [],
        allselected: false,
      })
    } else {
      return this.props.showError('No product available to be mapped.')
    }
  }

  onChangeSearch = (e) => {
    this.props.onChangeSearchTerm(e)
    this.setState({ selectedProductsMap: {} })
  }

  handleChangePage = (event, page) => {
    this.setState({ page })
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value })
  }

  render() {
    const {
      categoryList = [],
      lastModified = null,
      permitted = false,
      defaultTagMapping = {},
      tagMapping = [],
      productsList = [],
      brandsList = [],
      weedmapTags = [],
      thirdPartyProducts = {},
      thirdPartyBrands = [],
    } = this.props

    const {
      activeCategory,
      weedmapCategory,
      selectedProductsMap = {},
      wmTags = [],
      page,
      rowsPerPage,
      rowsPerPageOptions,
    } = this.state

    const mappingArray = tagMapping
    const mainCategories =
      (defaultTagMapping['MAIN_CATEGORY'] && defaultTagMapping['MAIN_CATEGORY']['']) || []
    const activeCategories = categoryList.filter((category) => category.active)
    const activeProducts = productsList && productsList.filter((product) => product.enableWeedmap)
    const wmCategory = mainCategories.find((cat) => cat.value == weedmapCategory) // eslint-disable-line
    const wmCategorySelect = mainCategories.find(
      (cat) =>
        (activeCategories[activeCategory] && activeCategories[activeCategory].wmCategory) ==
        cat.value,
    )

    const weedmapProducts = productsList || []

    const weedmapContent = (
      <Grid className="category-rightside">
        <Grid container>
          <Grid item sm={12} md={12} lg={12} xs={12} className="desktop-show margin-bottom-small">
            <span>
              BLAZE Category:{' '}
              {(activeCategories[activeCategory] && activeCategories[activeCategory].name) || ''}
            </span>
          </Grid>
          <Grid
            item
            sm={12}
            md={12}
            lg={12}
            xs={12}
            className="res-show blaze-category-dropdown margin-bottom-small"
          >
            <span>Blaze Category:</span>
            <Select
              value={activeCategory}
              onChange={(event) => this.handleCategoryChange(event, event.target.value)}
              MenuProps={{ className: 'no-backdrop-select' }}
            >
              {activeCategories.map((item, index) => {
                return (
                  <MenuItem key={index} value={index}>
                    {item.name}
                  </MenuItem>
                )
              })}
            </Select>
          </Grid>
          <Grid item sm={12} md={12} lg={12} xs={12} className="desktop-show margin-bottom-small">
            <span>WM Category: {(wmCategorySelect && wmCategorySelect.name) || ''}</span>
          </Grid>
          <Grid className="res-show weedmap-category-section" item sm={6} md={6} lg={6} xs={12}>
            <div className="weedmap-at-sec">
              <span>WM Category: </span>
              <Select
                value={weedmapCategory}
                onChange={this.setWeedmapCategory}
                MenuProps={{ className: 'no-backdrop-select' }}
                style={{ minWidth: 200, marginLeft: 10 }}
                disabled={true}
              >
                {mainCategories.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item.value}>
                      {item.name}
                    </MenuItem>
                  )
                })}
              </Select>
            </div>
          </Grid>
          <Grid className="weedmap-category-btn" item sm={12} md={12} lg={12} xs={12}>
            <Button
              className={`${
                weedmapProducts && weedmapProducts.length === 0
                  ? 'disabled-button'
                  : 'primary-button'
              } margin`}
              disabled={weedmapProducts && weedmapProducts.length === 0}
              onClick={this.openMapProductModal}
            >
              Add Product
            </Button>
          </Grid>
        </Grid>
        <div className="table-scroll">
          <SearchField
            value={this.props.term}
            onChange={this.onChangeSearch}
            onSearch={this.props.onSearch}
          />
          <Table
            className={`${weedmapProducts.length < 5 ? 'reverse-select' : 'outof-counts-select'}`}
          >
            <TableHead>
              <TableRow>
                <TableCell>Product Name</TableCell>
                <TableCell>Brand</TableCell>
                <TableCell>WM Product</TableCell>
                {permitted ? <TableCell></TableCell> : null}
              </TableRow>
            </TableHead>
            <TableBody>
              {activeProducts
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => {
                  const dataToEditIndex = mappingArray.findIndex((wmMap) => {
                    return wmMap.productId === item.id
                  })

                  const dataToEdit = mappingArray[dataToEditIndex]

                  const categoryId =
                    (activeCategories[activeCategory] && activeCategories[activeCategory].id) || ''

                  return (
                    <WeedMapMenuListItemV3Editable
                      product={item}
                      onSave={
                        dataToEditIndex !== -1 ? this.onSave(dataToEditIndex) : this.saveNewCategory
                      }
                      dataToEdit={
                        (dataToEdit && { ...dataToEdit }) || {
                          wmTags:
                            wmCategory && wmCategory.name
                              ? [(wmCategory && wmCategory.name) || '']
                              : [],
                          productId: item.id,
                          categoryId,
                          thirdPartyBrandId: '',
                          thirdPartyProductId: '',
                        }
                      }
                      weedMapList={weedMapList}
                      categoryList={categoryList}
                      onCancel={this.closeNewCategory}
                      defaultEditMode={false}
                      productsList={activeProducts.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )}
                      brandsList={brandsList}
                      weedmapTags={weedmapTags}
                      thirdPartyProducts={thirdPartyProducts}
                      weedmapCategory={wmCategory && wmCategory.name}
                      showError={this.props.showError}
                      thirdPartyBrands={thirdPartyBrands}
                      onRowCheck={this.onRowCheck}
                      selectedProductsMap={selectedProductsMap}
                      lastModified={lastModified}
                      lastUpdateTime={lastModified}
                      index={index}
                      onDelete={this.onDelete(dataToEditIndex)}
                      getWmMenuApiProducts={this.props.getWmMenuApiProducts}
                      getWmMenuApiBrands={this.props.getWmMenuApiBrands}
                      key={index + page * rowsPerPage}
                    />
                  )
                })}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  colSpan={6}
                  count={activeProducts.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  ActionsComponent={TablePaginationActionsWrapped}
                  rowsPerPageOptions={rowsPerPageOptions}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </Grid>
    )
    const productsToShow =
      productsList &&
      productsList.filter((product) => {
        return !product.enableWeedmap
      })

    this.state.productsToSync = this.state.productsToSync.filter((item) =>
      productsToShow.some((product) => product.id === item),
    )

    const isAllProductsSelectedToMap = productsToShow.length === this.state.productsToSync.length

    return (
      <Fragment>
        <Grid container>
          <div className="desktop-show">
            <PersistentDrawer
              drawerClass="category-drawer"
              headerTitle="Map Products"
              drawerTitle="Categories"
              drawerContent={
                <Grid className="category-sidebar">
                  <Tabs
                    classes={{
                      flexContainer: 'category-tabs',
                      indicator: 'no-tab-indicator',
                    }}
                    textColor="primary"
                    value={activeCategory}
                    onChange={this.handleCategoryChange}
                  >
                    {activeCategories.map((category) => {
                      return <Tab classes={{ selected: 'active' }} label={category.name} />
                    })}
                  </Tabs>
                </Grid>
              }
            >
              {weedmapContent}
            </PersistentDrawer>
          </div>
          <div className="res-show">
            <Fragment>{weedmapContent}</Fragment>
          </div>
        </Grid>
        <ModalDialog
          title={'Choose Products to Add'}
          ref={(c) => (this.addProductModal = c)}
          onConfirm={this.addProducts}
          onOpen={this.onOpen}
          confirmText={'Add Product'}
          onClose={(e) => {
            this.props.onChangeSearchTerm({ target: { value: '' } })
            setTimeout(() => this.props.onSearch(), 500)
          }}
          rootClass="modal-choose-pro"
          maxWidth="xs"
        >
          <div className="table-scroll product-map-modal">
            <SearchField
              value={this.props.term}
              onChange={this.props.onChangeSearchTerm}
              onSearch={this.props.onSearch}
            />
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell className="first-checkbox-column">
                    <EditableCheckbox
                      valueToRender={''}
                      editMode={true}
                      onChange={this.checkAllProducts}
                      className="table-cus-checkbox"
                      checked={isAllProductsSelectedToMap}
                    />
                  </TableCell>
                  <TableCell className="first-checkbox-column">Product Name</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {productsToShow.map((product, index) => (
                  <AddProductSync
                    key={index}
                    product={product}
                    onCheckProduct={this.onCheckProduct}
                    // allselected={this.state.allselected}
                    allselected={isAllProductsSelectedToMap}
                    mapProducts={this.state.mapProducts}
                    productsToSync={this.state.productsToSync}
                  />
                ))}
              </TableBody>
            </Table>
          </div>
        </ModalDialog>
        <Snackbar
          open={this.state.saved}
          autoHideDuration={2000}
          onClose={this.handleClose}
          message="Saved 👍"
          className="snackbar success"
        />
      </Fragment>
    )
  }
}

function mapStateToProps(state) {
  return {
    defaultTagMapping:
      (state.integrationReducer &&
        state.integrationReducer.weedmapAccount &&
        state.integrationReducer.weedmapAccount.defaultTagMapping) ||
      {},
  }
}

export default connect(mapStateToProps)(WeedMapMenuListContainerV3)

/* ------ PAGINATION ------ */
const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: 50,
  },
})

class TablePaginationActions extends React.Component {
  handleFirstPageButtonClick = (event) => {
    this.props.onChangePage(event, 0)
  }

  handleBackButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page - 1)
  }

  handleNextButtonClick = (event) => {
    this.props.onChangePage(event, this.props.page + 1)
  }

  handleLastPageButtonClick = (event) => {
    this.props.onChangePage(
      event,
      Math.max(0, Math.ceil(this.props.count / this.props.rowsPerPage) - 1),
    )
  }

  render() {
    const { classes, count, page, rowsPerPage, theme } = this.props

    return (
      <div className={classes.root}>
        <IconButton
          onClick={this.handleFirstPageButtonClick}
          disabled={page === 0}
          aria-label="First Page"
        >
          {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
        </IconButton>
        <IconButton
          onClick={this.handleBackButtonClick}
          disabled={page === 0}
          aria-label="Previous Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
        </IconButton>
        <IconButton
          onClick={this.handleNextButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Next Page"
        >
          {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        </IconButton>
        <IconButton
          onClick={this.handleLastPageButtonClick}
          disabled={page >= Math.ceil(count / rowsPerPage) - 1}
          aria-label="Last Page"
        >
          {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
        </IconButton>
      </div>
    )
  }
}

TablePaginationActions.propTypes = {
  classes: PropTypes.object.isRequired,
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
  theme: PropTypes.object.isRequired,
}

const TablePaginationActionsWrapped = withStyles(actionsStyles, { withTheme: true })(
  TablePaginationActions,
)



// WEBPACK FOOTER //
// ./src/components/WeedmapInfo/WeedMapMenuList/WeedMapMenuListContainerV3.js